import React, { FC } from 'react';
import { Icon, IconEnum } from '@investoro/core';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    padding: 15px 0 0 0;
    align-items: center;
    margin-bottom: -10px;
    cursor: pointer;

    @media (min-width: 768px) {
        grid-column: span 2;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;

    img {
        margin: 14px 0 0 4px;
    }
`;

const OpinionText = styled.p`
    --font-weight: 400;
    line-height: 21px;
    text-align: justify;
    margin-bottom: 15px;

`;

interface AiOpinionBoxProps {
    content: string;
    lengthMoreThanMobile?: boolean;
    lengthMoreThanWeb?: boolean;
    onClick: () => void;
    maxLength?: number;
}

const AiOpinionBox: FC<AiOpinionBoxProps> = ({ content, onClick }) => {
    return (
        <Wrapper onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            onClick();
        }}>
            <ContentWrapper>
                <Icon icon={IconEnum.AI_STARS} />
                <OpinionText>
                    {content} {<strong> więcej →</strong>}
                </OpinionText>
            </ContentWrapper>
        </Wrapper>
    );
};

export default AiOpinionBox;
